import * as React from "react";

import { cn } from "./utils";

const Input = React.forwardRef(
  ({ className, type, fullWidth, disableUnderline, startAdornment, endAdornment, ...props }, ref) => {
    const inputEl = (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:text-white",
          startAdornment && "pl-10",
          endAdornment && "pr-10",
          className
        )}
        ref={ref}
        {...props}
      />
    );
    if (startAdornment || endAdornment) {
      return (
        <div className="relative flex w-full items-center">
          {startAdornment && (
            <div className="absolute left-3 flex items-center pointer-events-none [&_.input-adornment]:cursor-pointer [&_.input-adornment]:pointer-events-auto">
              {startAdornment}
            </div>
          )}
          {inputEl}
          {endAdornment && (
            <div className="absolute right-3 flex items-center">
              {endAdornment}
            </div>
          )}
        </div>
      );
    }
    return inputEl;
  }
)
Input.displayName = "Input"

export { Input }
